import { render, staticRenderFns } from "./edit_validation_rule.vue?vue&type=template&id=2b7fc6fa"
import script from "./edit_validation_rule.vue?vue&type=script&lang=js"
export * from "./edit_validation_rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports